import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

interface LinkItem {
  name: string;
  url: string;
  description: string;
  color: string;
}

const links: LinkItem[] = [
  {
    name: "Queue Monitoring",
    url: "https://ca-claimster-monitoring-prod.ambitiousgrass-ac17c90c.westeurope.azurecontainerapps.io/admin/queues/",
    description: "Monitor background job queues and worker status",
    color: "bg-blue-500",
  },
  {
    name: "Webanalytics",
    url: "https://clarity.microsoft.com/projects/view/l7w1ichizh/dashboard?date=Last%203%20days",
    description: "View user behavior and sessions via Microsoft Clarity",
    color: "bg-purple-500",
  },
  {
    name: "Support",
    url: "https://app.helpdesk.com/tickets/all",
    description: "Access customer support tickets",
    color: "bg-green-500",
  },
  {
    name: "Email Templates",
    url: "https://account.postmarkapp.com/servers/17125115/templates",
    description: "Manage transactional email templates in Postmark",
    color: "bg-yellow-500",
  },
  {
    name: "Social Media",
    url: "https://analyze.buffer.com/",
    description: "View social media analytics on Buffer",
    color: "bg-pink-500",
  },
];

export default function LinksPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">External Tools</h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Quick access to external services and monitoring tools
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {links.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative flex flex-col overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className={`absolute top-0 right-0 h-2 w-full ${link.color} opacity-75`} />
            
            <div className="flex items-start justify-between">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                {link.name}
              </h3>
              <ArrowTopRightOnSquareIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-500" />
            </div>
            
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
              {link.description}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
}
